// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__1OQ0Z","Title":"Header_Title__30csM"};